class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.installCartIconGuard();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    // ✅ tránh bind trùng sau khi replaceWith icon mới
    if (cartLink.dataset.cartDrawerBound === '1') return;
    cartLink.dataset.cartDrawerBound = '1';

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }


  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        let containerToTrapFocusOn = null;

        if (this.classList.contains('is-empty')) {
          containerToTrapFocusOn =
            this.querySelector('.drawer__inner-empty') ||
            this.querySelector('.drawer__inner') ||
            document.getElementById('CartDrawer');
        } else {
          containerToTrapFocusOn =
            document.getElementById('CartDrawer') ||
            this.querySelector('.drawer__inner');
        }

        if (containerToTrapFocusOn && typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        } else {
          focusElement?.focus?.();
        }
      },
      { once: true }
    );


    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');

    // đảm bảo icon cart không bị hidden sau khi drawer đóng
    setTimeout(() => this.ensureCartIconVisible(), 0);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (!parsedState) return;

    // FIX: cart empty -> not empty, nhưng class is-empty có thể nằm trên host <cart-drawer>
    this.classList.remove('is-empty');

    const itemsEl = this.querySelector('cart-drawer-items');
    if (itemsEl) itemsEl.classList.remove('is-empty');

    const inner = this.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    // FIX: đừng để icon bị hidden do state trước đó
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      bubble.removeAttribute('hidden');
      bubble.classList.remove('is-hidden');
      bubble.style.display = '';
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections?.[section.id];
      if (!html) return;

      // ✅ FIX: cart-icon-bubble phải replace node, không set innerHTML
      if (section.id === 'cart-icon-bubble') {
        const cur = document.querySelector(section.selector) || document.getElementById(section.id);
        if (!cur) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector(section.selector) || doc.getElementById(section.id);
        if (next) cur.replaceWith(next);
        return;
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });


    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
      this.open();
    });
  }


  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  installCartIconGuard() {
    if (window.__hCartIconGuardInstalled) return;
    window.__hCartIconGuardInstalled = true;

    const unhide = () => {
      const icon =
        document.querySelector('#cart-icon-bubble') ||
        document.querySelector('.header__icon--cart') ||
        document.querySelector('a[href="/cart"], a[href^="/cart"]');

      if (!icon) return;

      const fix = (el) => {
        if (!el) return;
        try {
          el.removeAttribute('hidden');
          el.removeAttribute('aria-hidden');
          el.classList?.remove('is-hidden', 'hidden');
          if (el.style) {
            if (el.style.display === 'none') el.style.display = '';
            if (el.style.visibility === 'hidden') el.style.visibility = '';
            if (el.style.opacity === '0') el.style.opacity = '';
          }
        } catch (_) {}
      };

      fix(icon);
      let p = icon.parentElement;
      for (let i = 0; i < 10 && p && p !== document.body; i++) {
        fix(p);
        p = p.parentElement;
      }
    };

    // chạy ngay + chạy lại sau các tình huống hay làm icon “biến mất”
    const tick = () => setTimeout(unhide, 0);
    tick();

    document.addEventListener('DOMContentLoaded', tick, { passive: true });
    window.addEventListener('pageshow', tick);
    document.addEventListener('shopify:section:load', tick);

    // quan trọng: quan sát thay đổi class/hidden/style để “gỡ” ngay khi bị set
    const mo = new MutationObserver(() => tick());
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'aria-hidden'] });
  }


  ensureCartIconVisible() {
    const icon =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('a[href="/cart"], a[href^="/cart"]');

    if (!icon) return;

    const unhide = (el) => {
      if (!el) return;
      try {
        el.removeAttribute('hidden');
        el.removeAttribute('aria-hidden');
        el.classList?.remove('is-hidden', 'hidden');
        if (el.style) {
          el.style.display = '';
          el.style.visibility = '';
          el.style.opacity = '';
        }
      } catch (_) {}
    };

    unhide(icon);

    // gỡ hidden lên nhiều cấp cha (tránh trường hợp theme hide wrapper)
    let p = icon.parentElement;
    for (let i = 0; i < 12 && p && p !== document.body; i++) {
      unhide(p);
      p = p.parentElement;
    }
  }

}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer .drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }
}


customElements.define('cart-drawer-items', CartDrawerItems);
